import './polyfills';

import 'normalize.css';

import 'gsap';
import 'gsap/CSSPlugin';
import 'gsap/ScrollToPlugin';

require('ninelines-ua-parser');
